import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure Bootstrap CSS/JS are present by injecting CDN links if not already loaded.
function ensureBootstrapCDN(){
  try{
    const has = Array.from(document.styleSheets || []).some(s=> s.href && s.href.includes('bootstrap'));
    if(!has){
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css';
      link.crossOrigin = 'anonymous';
      link.onload = ()=>{ window.__bootstrapLoaded = true; console.log('Bootstrap CSS loaded (injected)'); };
      link.onerror = ()=>{ window.__bootstrapLoaded = false; console.warn('Failed to load injected Bootstrap CSS'); };
      document.head.appendChild(link);
    } else {
      window.__bootstrapLoaded = true;
    }

    // add JS bundle if missing
    const hasScript = Array.from(document.scripts || []).some(s=> s.src && s.src.includes('bootstrap'));
    if(!hasScript){
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/js/bootstrap.bundle.min.js';
      script.crossOrigin = 'anonymous';
      script.onload = ()=> console.log('Bootstrap JS loaded (injected)');
      document.body.appendChild(script);
    }
  }catch(e){
    console.warn('Bootstrap injection check failed', e);
  }
}

ensureBootstrapCDN();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
